import React from 'react'
import { Link } from 'react-router-dom'

function CTA() {
  let cv = "https://drive.google.com/file/d/1sLOV-jg8rsp0kVw0B3p_quVW0DSymVuq/view"
  return (
    <div className="cta">
      <a href={cv} download className="btn">
        Download CV
      </a>
      {window.screen.width > 600 ? (
        <Link to="/contact" className="btn btn-primary">
          Let's Talk
        </Link>
      ) : (
        <a href="#contact" className="btn btn-primary">
          Let's Talk
        </a>
      )}
    </div>
  )
}

export default CTA
